import React from "react";

const styles = {};

function Maintenance() {
  return (
    <>
      <div className="vh">
        <div>
          <div className="wrap">
            <h1>Maintenance mode</h1>
            <h2>
              <p>
                Sorry for the inconvenience.
                <br />
                Our website is currently undergoing scheduled maintenance.
                <br />
                <br />
              </p>
            </h2>
            <p>Thank you for your understanding.</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Maintenance;
